module.exports = __webpack_public_path__ + "img/favicon.d29a8d10.png";